module.exports = __webpack_public_path__ + "media/public/img/expedia-round-color-01-841cb90d4013cc00a515fc22061595c1.svg";